export const saveSessionMetadata = (token: any) => {
  const { userAccountId, expires, accessToken } = token;
  localStorage.setItem("ansible-reference-id", userAccountId);
  localStorage.setItem("ansible-auth-exp", String(expires));
  localStorage.setItem("accessToken", accessToken);
};
